module.exports = __webpack_public_path__ + "img/76.1.531fac3e.jpg";